import { unwrapPage } from '@/core/utils/agentPlanDashboard'
import { membershipApiMessage } from '@/core/utils/membershipAdmin'

/**
 * Tabla paginada de los paneles del agente y la agencia.
 * El componente define fetchPage(params) y, si filtra, extraParams().
 */
export default {
  data() {
    return {
      items: [],
      loading: false,
      errorMessage: null,
      perPage: 20,
      currentPage: { page: 1 },
      dataMeta: { from: 0, to: 0, of: 0 },
      total: 0,
      requestSeq: 0,
    }
  },
  mounted() {
    this.load(1)
  },
  methods: {
    extraParams() {
      return {}
    },
    async load(page = this.currentPage.page) {
      // Si el filtro o la página cambian antes de que responda, gana la última petición.
      const seq = ++this.requestSeq
      this.loading = true
      this.errorMessage = null
      try {
        const response = await this.fetchPage({ ...this.extraParams(), per_page: this.perPage, page })
        if (seq !== this.requestSeq) return
        const result = unwrapPage(response)
        this.items = result.items
        this.total = result.total
        this.dataMeta = { from: result.from, to: result.to, of: result.total }
        this.currentPage.page = result.page
      } catch (error) {
        if (seq !== this.requestSeq) return
        this.items = []
        this.errorMessage = membershipApiMessage(error, 'No se pudo cargar la información. Intenta de nuevo.')
      } finally {
        if (seq === this.requestSeq) this.loading = false
      }
    },
  },
}
